import {
  authProviderAtom,
  type AuthProviderType,
  authStore
} from '@/features/auth/atoms'

import { logout as _logout } from '../api/auth/logout'
import { signOut } from '../auth/amplify'

const _authProviderType = {
  COGNITO: async () => {
    await signOut()
  },
  AUTH0: async () => {
    await _logout()
  }
} satisfies Record<AuthProviderType, () => Promise<void>>

const type = authStore.get(authProviderAtom)
export const logout = _authProviderType[type!]
